import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import * as CryptoJS from 'crypto-js'
import { environment } from '../../environments/environment'
import { AlertService } from '../_services/index'
import { LoginService } from '../login/login.service'
import { AppService } from '../app.service'
import { DataService } from '../data.service'
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  model: any = { otp: '' }
  passwordType: any = 'password'
  confirmPasswordType: any = 'password'
  btnDisable: boolean
  currentUrl: any
  redirectUrl: any
  backRedirectUrl: any
  contentInfo: any = {}
  appConstant: any = {}
  logo: any
  constructor(
    private loginService: LoginService,
    private router: Router,
    private alertService: AlertService,
    private appService: AppService,
    private dataService: DataService
  ) { }

  ngOnInit(): void {
    this.appConstant = environment
    this.appService.getInformation().subscribe((data: any) => {
      this.contentInfo = JSON.stringify(data)
      localStorage.setItem('contentInfo', this.contentInfo)
      this.dataService.changeLocalData('update data')
      if (data.website_content.backend_logo.backend_logo != '') {
        this.logo =
          this.appConstant.contentImagePath +
          data.website_content.backend_logo.backend_logo
      }
    })
    if (this.router.url === '/brand-reset-password') {
      this.model.userType = 'brand'
      // this.redirectUrl ='/brand-reset-password'
      this.backRedirectUrl = '/brand-login'
    } else {
      this.model.userType = 'superuser'
      // this.redirectUrl='/reset-password'
      this.backRedirectUrl = '/'
    }
    this.currentUrl = this.router.url
    if (localStorage.getItem('forgotPasswordData')) {
      const getForgotPasswordData: any = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem('forgotPasswordData'),
          environment.secretKey
        ).toString(CryptoJS.enc.Utf8)
      )
      this.model.forgotPasswordPublicId =
        getForgotPasswordData.forgotPasswordPublicId
      this.model.email = getForgotPasswordData.email
    }
  }
  errorHandler(event: any): void {
    event.target.src = environment.logoNoImage
  }

  changePasswordType(): void {
    if (this.passwordType === 'password') {
      this.passwordType = 'text'
    } else {
      this.passwordType = 'password'
    }
  }

  changeConfirmPasswordType(): void {
    if (this.confirmPasswordType === 'password') {
      this.confirmPasswordType = 'text'
    } else {
      this.confirmPasswordType = 'password'
    }
  }

  changePassword(form: any): any {
    if (form) {
      this.btnDisable = true

      this.loginService.resetPassword(this.model).subscribe(
        (data: any) => {
          this.alertService.success(data.message)
          this.router.navigate([this.backRedirectUrl])
        },
        (err: any) => {
          this.btnDisable = false
          if (err.status === 400 || err.status === 401 || err.status === 404) {
            if (err.error.errorMessage) {
              this.alertService.error(err.error.errorMessage)
            }
            if (err.error.error) {
              this.alertService.error(err.error.error)
            }
          }
        }
      )
    }
  }
}
